import { List, ListProps } from '@mui/material'
import { Asset } from '../types'
import AssetNameListItemButton from './AssetNameListItemButton'
import AssetCompanyListItemButton from './AssetCompanyListItemButton'
import AssetProjectListItemButton from './AssetProjectListItemButton'
import AssetLevelListItemButton from './AssetLevelListItemButton'
import AssetLiftListItemButton from './AssetLiftListItemButton'

export interface AssetDetailsListProps extends Omit<ListProps, 'children'> {
  asset: Asset
  editable?: boolean
  afterUpdate?: (asset: Asset) => void
}

export default function AssetDetailsList({
  asset,
  editable,
  afterUpdate,
  ...props
}: AssetDetailsListProps) {
  return (
    <List {...props}>
      <AssetNameListItemButton
        key="name"
        asset={asset}
        editable={editable}
        afterUpdate={afterUpdate}
      />

      <AssetCompanyListItemButton
        key="company"
        asset={asset}
        editable={editable}
        afterUpdate={afterUpdate}
      />

      <AssetProjectListItemButton
        key="project"
        asset={asset}
        editable={editable}
        afterUpdate={afterUpdate}
      />

      {asset?.projectId && (
        <>
          <AssetLevelListItemButton
            key="level"
            asset={asset}
            editable={editable}
            afterUpdate={afterUpdate}
          />

          <AssetLiftListItemButton
            key="lift"
            asset={asset}
            editable={editable}
            afterUpdate={afterUpdate}
          />
        </>
      )}
    </List>
  )
}
